import { Project } from "@brg/api";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { useProjectsList } from "../../../../shared/hooks/api/useProjectsByFilter";
import { LayoutConst, bArray } from "../../../../core";
import { computeProjectMapTile } from "../../../../shared/helpers/types/computed/ComputedProject";
import { ProjectsGridNew } from "../../../../shared/components/grids";
import styled from "styled-components";
import { ItemType } from "shared/constants/itemType";
import { useHistory, useRouteMatch } from "react-router-dom";
import { IProjectLight } from "shared/common";

interface IBookLight extends IProjectLight {
  bookId: string
}

export const PSChaptersWrapper = styled.div<{isBooks?: boolean}>`
  margin-top: 24px;
  margin-bottom: 40px;


  @media(max-width: ${LayoutConst.screen.md}px) {
    // margin: 24px auto 0 min(calc(940px - 100vw)/2 , 10px);
    margin: 24px 16px auto;
    width: 100%;
  }

  @media(max-width: 834px) {
    // margin: 24px 0 40px min(calc(940px - 100vw)/2 , 10px);
    width: 100%;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0 auto 24px 0;
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }
`;

type PropsT = {
  project: Project;
  disabled?: boolean;
  isLoading?: boolean;
  onLoading?: (loading: boolean) => void;
};

export const PSChapters: FC<PropsT> = ({ project, disabled, isLoading, onLoading }) => {
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const isHseDesign = AppTester.isHSEDesign();
  const isBooks = AppTester.isBooks();
  const isBookProjectPreview = !!useRouteMatch(["/books/book-preview", '/book-preview']);

  const projectsFilter = useMemo(() => ({
    projectFilter: 8,
    isLite: false,
    bookId: project.projectId,
    isContextIgnored: true
  }), [project]);

  const noPresentation = true;

  const [time, setTime] = useState<number | undefined>(undefined);

  const [allProjects, isLoadings] = useProjectsList(projectsFilter, i18n.language, time, time === undefined);

  const publishedProjects = useMemo(
    () =>
      bArray.isArray(allProjects?.data)
        ? allProjects?.data?.filter((p) => {
                //@ts-ignore
          if (noPresentation && ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large']?.includes(p?.projectType)) {
            return false;
          }

          return p;
        }) || []
        : [],
    [allProjects, noPresentation]
  );

  useEffect(() => {
    setTime(Date.now())
  }, [project?.projectId])

  const onBookChapterClick = useCallback((project: IProjectLight, e: any) => {
    const book = project as IBookLight;
    if (!!isBookProjectPreview && book) {
      const path = isHseDesign ? `/books/preview/${book?.identifier}` : `/book-preview/${book?.identifier}`;
      history.push(path + `?mainBookId=${book?.bookId}`);
      return;
    }

  }, [isBookProjectPreview, isHseDesign, history])

  return (
      <PSChaptersWrapper isBooks={isBooks}>
        <ProjectsGridNew 
          isLoading={isLoadings} 
          isModal={isBookProjectPreview} 
          onProjectClick={onBookChapterClick} 
          isCanNotBeDraft 
          isCanNotBeBookmark 
          itemType={ItemType.book} 
          linkPrefix={!AppTester.isBooksMain() ? "/books" : undefined} 
          // @ts-ignore
          projects={publishedProjects.map(computeProjectMapTile)}
        />
      </PSChaptersWrapper>
    );
};
import { Project } from "@brg/api";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { AppTester } from "supporting";
import { useProjectsList } from "../../../../shared/hooks/api/useProjectsByFilter";
import { LayoutConst, bArray } from "../../../../core";
import { computeProjectMapTile } from "../../../../shared/helpers/types/computed/ComputedProject";
import { ProjectsGridNew } from "../../../../shared/components/grids";
import styled from "styled-components";
import { ItemType } from "shared/constants/itemType";
import { useHistory, useRouteMatch } from "react-router-dom";
import { IProjectLight } from "shared/common";

interface IBookLight extends IProjectLight {
  bookId: string
}

export const PSChaptersWrapper = styled.div<{isBooks?: boolean}>`
  margin-top: 24px;
  margin-bottom: 40px;


  @media(max-width: ${LayoutConst.screen.md}px) {
    // margin: 24px auto 0 min(calc(940px - 100vw)/2 , 10px);
    margin: 24px 16px auto;
    width: 100%;
  }

  @media(max-width: 834px) {
    // margin: 24px 0 40px min(calc(940px - 100vw)/2 , 10px);
    width: 100%;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin: 0 auto 24px 0;
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }
`;

type PropsT = {
  project: Project;
  disabled?: boolean;
  isLoading?: boolean;
  onLoading?: (loading: boolean) => void;
};

export const PSChapters: FC<PropsT> = ({ project, disabled, isLoading, onLoading }) => {
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const isHseDesign = AppTester.isHSEDesign();
  const isBooks = AppTester.isBooks();
  const isBookProjectPreview = !!useRouteMatch(["/books/book-preview", '/book-preview']);

  const projectsFilter = useMemo(() => ({
    projectFilter: 8,
    isLite: false,
    bookId: project.projectId,
    isContextIgnored: true
  }), [project]);

  const noPresentation = true;

  const [time, setTime] = useState<number | undefined>(undefined);

  const [allProjects, isLoadings] = useProjectsList(projectsFilter, i18n.language, time, time === undefined);

  const publishedProjects = useMemo(
    () =>
      bArray.isArray(allProjects?.data)
        ? allProjects?.data?.filter((p) => {
                //@ts-ignore
          if (noPresentation && ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large']?.includes(p?.projectType)) {
            return false;
          }

          return p;
        }) || []
        : [],
    [allProjects, noPresentation]
  );

  useEffect(() => {
    setTime(Date.now())
  }, [project?.projectId])

  const onBookChapterClick = useCallback((project: IProjectLight, e: any) => {
    const book = project as IBookLight;
    if (!!isBookProjectPreview && book) {
      const path = isHseDesign ? `/books/preview/${book?.identifier}` : `/book-preview/${book?.identifier}`;
      history.push(path + `?mainBookId=${book?.bookId}`);
      return;
    }

  }, [isBookProjectPreview, isHseDesign, history])

  return (
      <PSChaptersWrapper isBooks={isBooks}>
        <ProjectsGridNew 
          isLoading={isLoadings} 
          isModal={isBookProjectPreview} 
          onProjectClick={onBookChapterClick} 
          isCanNotBeDraft 
          isCanNotBeBookmark 
          itemType={ItemType.book} 
          linkPrefix={!AppTester.isBooksMain() ? "/books" : undefined} 
          // @ts-ignore
          projects={publishedProjects.map(computeProjectMapTile)}
        />
      </PSChaptersWrapper>
    );
};
